import React, { useEffect, useState } from 'react';
import ProspectPropertyService from '../../../Service/ProspectPropertyService';
import { Timeline } from "primereact/timeline";

const QueriesHistoryPage = ({ queryId }) => {
  const [events, setEvents] = useState([]);

  const fetchQueryHistory = async (queryId) => {
    try {
      const response = await ProspectPropertyService.getQueryHistoryById(queryId);
      console.log('Query History:', response.data?.queryHistory);
      setEvents(response.data?.queryHistory || []);
    } catch (error) {
      console.error('Error fetching query history:', error);
    }
  };

  useEffect(() => {
    fetchQueryHistory(queryId);
  }, [queryId]);

  return (
    <div className='p-4 border border-slate-200 rounded-[10px]'>
      {/* Title */}
      <div className='text-customGreen font-semibold text-xl mb-3'>
        Query History
      </div>

      {/* Timeline */}
      {events.length > 0 ? (
        <div className="h-[350px] overflow-y-auto mt-2 custom-scrollbar">
          <Timeline
            className="px-4 mt-4"
            value={events}
            opposite={(item) => (
              <div className="text-gray-500 text-sm">
                {item.timestamp}
              </div>
            )}
            content={(item) => (
              <div className="text-gray-700 mb-4 text-base leading-relaxed">

                {item.log&& (
                  <div className="font-medium text-gray-700 ">{item.log}</div>
                )}
                
                {item.changeByName && (
                  <>  <span className='mt-1 text-sm '>{item.changeByName}</span></>
                )}
                
              </div>
            )}
            marker={(item) => (
              <span
                className="custom-marker rounded-full w-4 h-4 block"
                style={{ borderColor: "#399E79", borderWidth: "3px" }}
              ></span>
            )}
          />
        </div>
      ) : (
        <div className="text-gray-400 text-sm mt-4">No history available.</div>
      )}
    </div>
  );
};

export default QueriesHistoryPage;
